import React from "react"
import { Helmet } from "react-helmet"
import favicon from "../../images/favicon.png"

const SEO = props => {
  const { title, description, url } = props.siteMetadata

  return (
    <Helmet defer={false} >
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="icon" href={`${favicon}`} type="image/png" />
      <link
        as="font"
        rel="preload"
        href="/static/ProximaNova-Bold-926a08fb27e3303c7452b0bdd2d5e5ab.ttf"
        crossorigin
      />
      <link
        as="font"
        rel="preload"
        href="/static/ProximaNova-Light-0188899cd3ec92cdcaa4c97ca0c75247.ttf"
        crossorigin
      />
      <link
        as="font"
        rel="preload"
        href="/static/ProximaNova-Regular-7ce6760d17685c466ba04d1b2c63c38b.ttf"
        crossorigin
      />
      <link
        as="font"
        rel="preload"
        href="/static/ProximaNova-Semibold-df8c626474a73ab7a8b511655597c7c4.ttf"
        crossorigin
      />

      <meta name="url" content={url} />
      <meta property="og:url" content={url} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
    </Helmet>
  )
}
export default SEO
